
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/replacing-implant",
      function () {
        return require("private-next-pages/replacing-implant.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/replacing-implant"])
      });
    }
  